export const screenSizes = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const

export const breakpoints = Object.values(screenSizes).map((size) => `${size}px`)

export const theme = {
  breakpoints,
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
}
